<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M22.8217 13.3208H24.4446V10.1408C24.1646 10.0975 23.2017 10 22.0803 10C19.7405 10 18.1377 11.6558 18.1377 14.6992V17.5H15.5557V21.055H18.1377V30H21.3033V21.0558H23.7809L24.1742 17.5008H21.3026V15.0517C21.3033 14.0242 21.5492 13.3208 22.8217 13.3208Z"
    fill={primary200}
  />
  <path
    d="M26.667 25.186V30.3712"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24.0742 27.7791H29.2594"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
